// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1g0HR","right":"Footer_right__2aalU","buttons":"Footer_buttons__3F5x8"};